import { useEffect, useState } from "react";
import Button from "@weave-design/button";
import Modal from "@weave-design/modal";
import { WeaveDesignStylesheet } from "../../../../sharedTypes";
import { ImperialAndMetricDimensionEditor } from "../../../editor-inputs/imperialAndMetricDimensionEditor";
import "./linkedModelCard.css";

type Props = {
    origin: THREE.Vector3;
    updateLinkedModelOrigin: (newOrigin: THREE.Vector3) => void;
    close: () => void;
};

export const LinkedModelOriginEditorDialog = ({ origin, updateLinkedModelOrigin, close }: Props) => {
    const [x, setX] = useState(0);
    const [y, setY] = useState(0);
    const [z, setZ] = useState(0);

    useEffect(() => {
        setX(origin.x);
        setY(origin.y);
        setZ(origin.z);
    }, [origin]);

    const onConfirm = () => {
        updateLinkedModelOrigin(new THREE.Vector3(x, y, z));
    };

    return (
        <Modal open title="Origin Editor" onCloseClick={close} stylesheet={modalStyles}>
            <div className="linked-model-origin">
                <div>
                    <ImperialAndMetricDimensionEditor title="X:" value={x} onChange={setX} />
                    <ImperialAndMetricDimensionEditor title="Y:" value={y} onChange={setY} />
                    <ImperialAndMetricDimensionEditor title="Z:" value={z} onChange={setZ} />
                </div>

                <div className="linked-model-origin__actions">
                    <Button type="secondary" size="standard" title="Cancel" onClick={close} />
                    <Button type="primary" size="standard" title="Confirm" onClick={onConfirm} />
                </div>
            </div>
        </Modal>
    );
};

const modalStyles = (styles: WeaveDesignStylesheet) => ({
    ...styles,
    modal: {
        ...styles.modal,
        window: {
            ...styles.modal.window,
            top: "calc(50% - 120px)",
        },
        bodyContent: {
            ...styles.modal.bodyContent,
            overflow: "hidden", // no scrollbar
        },
    },
});
